export default {"src":"/_next/static/media/dot.5f94bdd9.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};